module.exports = __webpack_public_path__ + "img/product-sales-portal.2b4bc22f.png";